import { createActions, createReducer } from 'reduxsauce'

import ConsultaRestosPagarService from '../../servicos/ConsultaRestosPagarService'

/**
 * Action types & creators
 */
export const { Types, Creators } = createActions({
    buscaConsultaRestosPagarInicio: [],
    buscaConsultaRestosPagarErro: ['erro'],
    buscaConsultaRestosPagarSucesso: ['consultaRestosPagar'],
    limpar: [],
    setConsultaRestosPagarEstadoDT: ['estado'],
})

const INITIAL_STATE = {
    carregando: false,
    erro: null,
    lista: [],
    dataSincronizacaoDados: null,
    estadoDT: {},
}

// Ação para busca completa
Creators.buscaConsultaRestosPagar = filtro => {
    return dispatch => {
        dispatch(Creators.buscaConsultaRestosPagarInicio())
        let serv = new ConsultaRestosPagarService()
        return serv
            .consultar(filtro)
            .then(response => dispatch(Creators.buscaConsultaRestosPagarSucesso(response.data)))
            .catch(error => dispatch(Creators.buscaConsultaRestosPagarErro(error)))
    }
}

const buscaConsultaRestosPagarInicio = (state = INITIAL_STATE, action) => ({ ...state, carregando: true, erro: null })

const buscaConsultaRestosPagarErro = (state = INITIAL_STATE, action) => ({ ...state, erro: action.erro, carregando: false })

const buscaConsultaRestosPagarSucesso = (state = INITIAL_STATE, action) => {
    return {
        ...state,
        lista: action.consultaRestosPagar.resultado,
        dataSincronizacaoDados: action.consultaRestosPagar.dataSincronizacaoDados,
        fonte: action.consultaRestosPagar.fonte,
        carregando: false,
    }
}

const limpar = (state = INITIAL_STATE, action) => {
    return INITIAL_STATE
}

const setConsultaRestosPagarEstadoDT = (state = INITIAL_STATE, action) => {
    return { ...state, estadoDT: action.estado }
}

/**
 * Reducer
 */
export default createReducer(INITIAL_STATE, {
    [Types.BUSCA_CONSULTA_RESTOS_PAGAR_INICIO]: buscaConsultaRestosPagarInicio,
    [Types.BUSCA_CONSULTA_RESTOS_PAGAR_ERRO]: buscaConsultaRestosPagarErro,
    [Types.BUSCA_CONSULTA_RESTOS_PAGAR_SUCESSO]: buscaConsultaRestosPagarSucesso,
    [Types.LIMPAR]: limpar,
    [Types.SET_CONSULTA_RESTOS_PAGAR_ESTADO_DT]: setConsultaRestosPagarEstadoDT,
})
